import { isIos, addQiniuParams } from "@ykz/ykz-util/platform";
import { extend } from "@ykz/ykz-util/base";

//input滚动到输入法顶部,parElem目标元素的滚动父元素，childElem目标元素，height固定栏遮挡物的高度,不传默认为0
export function inputScrollIntoView(parElem, childElem, height) {
  if (isIos()) {
    return; //ios系统自带input滚动到输入法顶部的方法
  }
  height = height || 0;
  const resize = function() {
    if (
      childElem.offsetTop + childElem.offsetHeight - parElem.scrollTop >
      window.innerHeight - height
    ) {
      // 目标滚动高度
      const scrollTop =
        childElem.offsetTop +
        childElem.offsetHeight +
        height -
        parElem.offsetHeight;

      if (parElem.scrollTop != scrollTop) {
        scroll(scrollTop - parElem.scrollTop);
      }
      // 动态滚动 [s = scrollTop , t = 250(默认)]
      const scroll = function(s, t = 250) {
        let sp = 10; //也可根据当前scrollTop动态改变sp的值， 从而实现加速和减速滚动的效果
        let cont = Number.parseInt(t / sp); // 滚动次数
        let oneLong = s / cont; // 单次的滚动单位
        let timer = setInterval(() => {
          if (cont > 0) {
            cont--;
            parElem.scrollBy(0, oneLong);
          } else {
            clearInterval(timer);
          }
        }, sp);
      };
    }
    window.removeEventListener('resize',resize)
  };
  window.addEventListener("resize", resize);
}

export function convertHTML(element,content) {
  return jQuery(element).html(content)
}

//对特色介绍富文本字符串，懒加载处理
export function lazyWithStr(htmlStr) {
  let isString = htmlStr && typeof htmlStr == "string";
  if (isString) {
    //兼容ios系统（富文本封装成jq对象，即使立即替换图片路径，也会加载原图片资源），使用正则表达式，处理img标签数据
    // 旧的正则
    // htmlStr = htmlStr.replace(/<img (.*?)src=['"](.*?)['"](.*?)>/g, '<img $1src="" data-src="$2"$3>');

    // 新的正则(解决不了标签缺失等乱七八糟的问题)
    htmlStr = htmlStr.replace(/<img\s+([^>]*?)\s+src=['"](.*?)['"]([^>]*?)>/g, function(match, p1, p2, p3) {
      // p1 是 img 标签的其他属性，p2 是 src 属性的值，p3 是 src 后面的其他属性
      return `<img ${p1}src="" data-src="${p2}"${p3}>`;
    });
  }

  let $obj = document.createElement('div');
  if (isString) {
    jQuery($obj).html(htmlStr)
    // $obj.innerHTML = htmlStr
  } else {
    $obj.appendChild(htmlStr)
  }

  // let imgArray = Array.from($obj.childNodes).filter(item => item.tagName === 'IMG')||[]; // 图片节点列表
  let imgArray = Array.from($obj.querySelectorAll('img')||[])
  imgArray.forEach(e => {
    var src = e.dataset.src || '';
    if (src.search("135editor.") != -1) {
      src = src.replace("https://", "http://"); //绕过135editor.com站点的防盗链机制
    }
    src = addQiniuParams(
      src,
      "?imageView2/2/w/702/interlace/1/q/85/",
      "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_400.png"
    );
    e.dataset.src = src;
    e.dataset.original = src;
    e.src = '//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_400.png';
    e.classList.add("lazy");
  })

  // let embedArray = Array.from($obj.childNodes).filter(item => item.tagName === 'EMBED') || []; // embed节点列表
  let embedArray = Array.from($obj.querySelectorAll('EMBED')||[])
  if (embedArray.length) {
    let insertSort = 0;
    const getCover = embed=> {
      if (embed.attributes['video-cover-url']) {
        return embed.attributes['video-cover-url'].value
      }
      return false
    }
    const insertDom = html=> {
      var element = document.createElement('div');
      // element.innerHTML = html
      jQuery(element).html(html)
      return element.childNodes[0]
    }
    embedArray.forEach(embed => {
      let src = embed.attributes['src'].value;
      let html = '<div class="J_TCPlayer" data-fileid="' + 
            src + 
            '"' +
            (getCover(embed)?' video-cover-url="' + getCover(embed) +'"':'') +
            'style="margin-bottom:0.4rem;position:relative"></div>';
      $obj.insertBefore(insertDom(html),$obj.childNodes[insertSort])
      insertSort++;
    });
  }
  // $obj.innerHTML
  return jQuery($obj).html();
}
/**
 * [getScript 使用jq加载script，返回deferred对象]
 * 默认cache=true，并且加载前先移除全局window.define对象，避免当成amd模式引入
 * 加载成功后恢复window.define变量
 * @param  {[type]} url     [description]
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
export function getScript(url, options) {
  var _tempDefine = window.define;
  window.define = null;

  options = extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  var cb_complete = options.complete || function() {};

  options.complete = function() {
    window.define = _tempDefine;
    cb_complete.apply(this, arguments);
  };

  return jQuery.ajax(options);
}

/**
 * [initIScroll 为元素创建iscroll层的滚动效果，并提供一些回调方法]
 * @param  {[type]} options [description]
 * {
 *     el:".content", // 父级滚动容器元素选择器
 *     limit: 60, // 上拉、下拉触发回调函数的阀值 (默认值：60，单位：px)
 *     onSlideScroll:function(),//滚动事件
 *     onPullDownTrigger: function, // 下拉达到阀值松开手指触发回调函数
 *     onPullUpTrigger: function, // 上拉达到阀值松开手指触发回调函数
 *     onSlideBottom: function, // 每当滚动到底部时候
 *     onSlideTop: function, // 每当滚动到顶部时候
 *     onSlideBottomOnce: function, // 触摸一次滚动到底部时候(只触发一次)
 *     onSlideTopOnce: function, // 触摸一次滚动到顶部时候(只触发一次)
 *     onSlideBottomLimitOnce:function, // 当触摸滚动到底部limit值时触发(只触发一次)
 * }
 * @return {[type]}         [返回IScroll实例化对象]
 */
export function initIScroll(options) {
  /*
    if (!options.initCount) {
        options.initCount = 1
    } else {
        options.initCount++;
    }

    if (typeof window.IScroll != "function" && options.initCount == 1) {
        console.error("缺少IScroll插件，尝试动态加载IScroll库");
        loadScript("/src/js/lib/iscroll.js?v=" + window.staticVersion, function(e) {
            if (typeof window.IScroll == "function") {
                initIScroll(options);

            } else {
                console.error("加载IScroll库失败");
            }
        })
        return false;
    }*/

  if (typeof window.IScroll != "function") {
    console.error("缺少IScroll插件，请引入lib下IScroll库");
    return false;
  }

  var _defOpt = {
    el: "",
    limit: 60,
    inited: function() {},
    onPullUpTrigger: function() {},
    onPullDownTrigger: function() {},
    onSlideBottom: function() {},
    onSlideTop: function() {},
    onSlideScroll: function() {},
    onSlideBottomOnce: function() {},
    onSlideTopOnce: function() {},
    onSlideBottomLimitOnce: function() {},
    bounce: true
  };
  // options = $.extend(true, _defOpt, options);
  options = extend(_defOpt, options);
  console.log(options);

  var $el = $(options.el);
  $el.on("touchstart", function(e) {
    myScroll.refreshFlag = false;
    myScroll.slideBottomFlag = false;
    myScroll.slideTopFlag = false;
    myScroll.slideBottomOnceCount = 0; //触摸滑动时候碰到底部的计数
    myScroll.slideTopOnceCount = 0; //触摸滑动时候碰到顶部的计数
    myScroll.slideBottomLimitOnceCount = 0;
    clearTimeout(myScroll.touchTimer);
  });
  $el.on("touchend", function(e) {
    if (myScroll.pullDownTrigger) {
      console.show("iscroll: 执行下拉达到阀值刷新回调------------------");
      typeof options.onPullDownTrigger == "function" &&
        options.onPullDownTrigger();
    }
    if (myScroll.pullUpTrigger) {
      console.show("iscroll: 执行上拉达到阀值加载回调------------------");
      typeof options.onPullUpTrigger == "function" && options.onPullUpTrigger();
    }
    myScroll.touchTimer = setTimeout(function() {
      myScroll.pullDownTrigger = myScroll.pullUpTrigger = false;
    }, 500);
  });

  let $wrapper = $el.find(".J_Wrapper");
  $el.css({
    overflow: "hidden"
  });

  //若子级没有.J_Wrapper 元素，自动添加一个用以补全，但注意会导致vue的 if语句异常
  //故建议使用该插件，自主补全该元素
  if ($wrapper.length == 0) {
    $el.wrapInner("<div class='J_Wrapper'></div>");
    $wrapper = $el.find(".J_Wrapper").eq(0);
  }

  var iscrollOptions = {
    click: true,
    probeType: 3,
    mouseWheel: false
  };
  if (typeof options.bounce != "undefined") {
    //是否弹力动画效果
    iscrollOptions.bounce = options.bounce;
  }

  if (iscrollOptions.bounce) {
    //确保iscroll容器能够上下弹性滚动
    $wrapper.css({
      "min-height": $el.height() + 1
    });
  }
  var myScroll = new IScroll($el[0], iscrollOptions);

  typeof options.inited == "function" && options.inited.call(myScroll);

  myScroll.on("scroll", function() {
    if (pageScroll.scrollerHeight != $wrapper.height()) {
      pageScroll.refresh();
      myScroll.refreshFlag = true;
      console.show("刷新高度");
    }

    var y = this.y,
      maxY = this.maxScrollY - y;
    var limit = ~~options.limit;
    var toTopDistance = ~~options.toTopDistance;
    if (typeof limit != "number" || limit == 0) {
      limit = 60;
    }
    if (y >= limit && !myScroll.pullDownTrigger) {
      console.show("iscroll: 下拉刷新到了阀值");
      myScroll.pullDownTrigger = true;
    } else if (y < limit && y > 0 && myScroll.pullDownTrigger) {
      console.show("iscroll: 下拉刷新取消到了阀值");
      myScroll.pullDownTrigger = false;
    }

    typeof options.onSlideScroll == "function" &&
      options.onSlideScroll.call(this);

    if (maxY >= limit) {
      myScroll.slideBottomLimitOnceCount++;
      if (!myScroll.pullUpTrigger) {
        console.show("iscroll: 上拉加载到了阀值");
        myScroll.pullUpTrigger = true;
      }
      if (myScroll.slideBottomLimitOnceCount == 1) {
        console.show("iscroll: 上拉加载onSlideBottomLimit事件触发");
        typeof options.onSlideBottomLimitOnce == "function" &&
          options.onSlideBottomLimitOnce.call(this);
      }
    }

    if (y >= 0 && !myScroll.slideTopFlag) {
      myScroll.slideTopOnceCount++;
      myScroll.slideTopFlag = true;
      console.show("iscroll: 滚动到顶部");
      typeof options.onSlideTop == "function" && options.onSlideTop.call(this);

      if (myScroll.slideTopOnceCount == 1) {
        typeof options.onSlideTopOnce == "function" &&
          options.onSlideTopOnce.call(this);
      }
    } else if (y < 0) {
      myScroll.slideTopFlag = false;
    }

    if (maxY >= 0 && !myScroll.slideBottomFlag) {
      myScroll.slideBottomOnceCount++;
      myScroll.slideBottomFlag = true;
      console.show("iscroll: 滚动到底部");
      typeof options.onSlideBottom == "function" &&
        options.onSlideBottom.call(this);

      if (myScroll.slideBottomOnceCount == 1) {
        typeof options.onSlideBottomOnce == "function" &&
          options.onSlideBottomOnce.call(this);
      }
    } else if (maxY < 0) {
      myScroll.slideBottomFlag = false;
    }
  });
  return myScroll;
}
